export function currentEnvironment() {
  const currentHostName = window.location.host.toLowerCase();

  if (currentHostName.indexOf("localhost") >= 0) return "localhost";
  if (currentHostName.indexOf("dev") >= 0) return "dev";
  if (currentHostName.indexOf("test") >= 0) return "test";
  if (currentHostName.indexOf("uat") >= 0) return "uat";
  if (currentHostName.indexOf("kundserviceapp.avtalat.se") >= 0) return "prod";

  const warningMessage = `The current environment (${currentHostName}) is not registered in the helper function currentEnv which caused it to return null. This might result in unwanted behaviour.`;
  console.warn(warningMessage);

  return "unknown";
}
